export enum EGizmoReason {
    None,
    GizmoUsedThisRound,
    GizmoUsedByPlayer,
    InvalidState
}
